import { ColumnConfig, ColumnConfigData } from "./ColumnConfig";
import { HeliosTableConfig } from "./helios/TableConfig";

type TableConfigData = {
  name: string;
  position: number;
  columnNames: ColumnConfigData[];
  helios?: HeliosTableConfig;
};

class TableConfig {
  name: string = "";
  position: number;
  columnNames: ColumnConfig[] = [];
  helios?: HeliosTableConfig;

  constructor(data: TableConfigData) {
    this.name = data.name;
    this.position = data.position;
    this.columnNames = data.columnNames.map((x) => new ColumnConfig(x));
    this.columnNames.sort((a, b) => a.position - b.position);

    this.helios = data.helios;
  }

  /**
   *
   * @param field Object containing fieldName property
   * @param newPosition 0-based index of new field position.
   */
  changeFieldOrder(field: { fieldName: string }, newPosition: number): void {
    if (newPosition > this.columnNames.length - 1 || newPosition < 0) {
      throw new Error(`Invalid position ${newPosition} provided`);
    }
    const fieldIndex = this.columnNames.findIndex(
      (x) => x.fieldName === field.fieldName,
    );
    if (fieldIndex === -1) {
      throw new Error(
        `Cannot change order of non-existent field ${field?.fieldName}`,
      );
    }
    // remove field to avoid duplicate array entry
    const [removedField] = this.columnNames.splice(fieldIndex, 1);
    // insert removed field into new position
    this.columnNames.splice(newPosition, 0, removedField);
    // update all field positions based on current index.
    this.columnNames.forEach((f, i) => {
      f.position = i;
      if (f.helios) {
        f.helios.position = i;
      }
    });
  }

  updateColumnConfig(columnConfig: ColumnConfig) {
    let index = this.columnNames.findIndex(
      (x) => x.fieldName === columnConfig.fieldName,
    );
    // if(fieldIndex)
    let removeCount: number = 1;
    if (index == -1) {
      // TODO: would allocating to end of the array be faster ?
      // if our object doesn't exist, insert at start of array.
      removeCount = 0;
      index = 0;
    }
    // insert or update the object
    this.columnNames.splice(index, removeCount, columnConfig);
  }

  getDocFieldConfig(columnName: string): ColumnConfig | undefined {
    return this.columnNames.find((column) => column.fieldName === columnName);
  }

  toData(): TableConfigData {
    return {
      name: this.name,
      columnNames: this.columnNames.map((x) => x.toData()),
      helios: this.helios ? { ...this.helios } : undefined,
      position: this.position,
    };
  }

  static createTest(rest: Partial<TableConfigData> = {}): TableConfig {
    const data: TableConfigData = {
      name: "",
      columnNames: [],
      position: 0,
    };

    return new TableConfig({
      ...data,
      ...rest,
    });
  }
}

export { TableConfig, TableConfigData };
